<template>
  <v-text-field
    ref="scanField"
    v-model="input"
    :label="label || use_language.scan_search_product"
    :placeholder="use_language.scan_or_type_to_filter"
    prepend-inner-icon="mdi-barcode-scan"
    outlined
    dense
    hide-details
    autofocus
    clearable
    :disabled="disabled"
    :loading="loading"
    @input="onType"
    @click:clear="onClear"
    @keydown.enter.prevent="onEnter"
  />
</template>

<script>
import axios from 'axios'
import { stockService_dotnet } from '@/website/global'
import { get_languages } from '@/website/global_function'

export default {
  name: 'PosScanInput',
  props: {
    warehouseId: { type: [Number, String], default: null },
    disabled: { type: Boolean, default: false },
    label: { type: String, default: '' }
  },
  data: () => ({
    use_language: {},
    header_token: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('authorization_token') },
    input: '',
    loading: false,
    typeTimer: null
  }),
  beforeDestroy () {
    if (this.typeTimer) clearTimeout(this.typeTimer)
  },
  async created () {
    this.use_language = await this.get_languages(localStorage.getItem("set_language"))
  },
  methods: {
    get_languages,
    focus () {
      this.$nextTick(() => {
        if (this.$refs.scanField) this.$refs.scanField.focus()
      })
    },
    onType (v) {
      if (this.typeTimer) clearTimeout(this.typeTimer)
      this.typeTimer = setTimeout(() => {
        this.$emit('search', (v || '').trim())
      }, 350)
    },
    onClear () {
      if (this.typeTimer) clearTimeout(this.typeTimer)
      this.input = ''
      this.$emit('search', '')
      this.focus()
    },
    reset () {
      if (this.typeTimer) clearTimeout(this.typeTimer)
      this.input = ''
      this.$emit('search', '')
    },
    async onEnter () {
      const term = (this.input || '').trim()
      if (!term) return
      if (!this.warehouseId) {
        this.$swal({ position: 'top', type: 'warning', text: this.use_language.select_warehouse_first })
        return
      }
      if (this.typeTimer) clearTimeout(this.typeTimer)
      this.loading = true
      try {
        const res = await axios.post(
          stockService_dotnet + 'Stock/get-stock-list-addorder',
          {
            shopID: localStorage.getItem('shop_id'),
            keyword: term,
            sku: null,
            name: null,
            barcode: null,
            warehouseID: this.warehouseId,
            isNeedResultCount: true,
            skipProductMasterItemIDList: [],
            isProductSet: null,
            skip: 0,
            take: 50
          },
          { headers: this.header_token }
        )
        const list = (res.data && res.data.stockList) || []
        const exact = list.find(p =>
          (p.barcode && String(p.barcode).trim() === term) ||
          (p.sku && String(p.sku).trim() === term)
        )
        const hit = exact || (list.length === 1 ? list[0] : null)

        if (hit) {
          this.$emit('add-item', hit)
          this.reset()
        } else if (list.length === 0) {
          this.$swal({
            position: 'top',
            toast: true,
            timer: 1500,
            showConfirmButton: false,
            type: 'warning',
            title: this.use_language.product_not_found + ' ' + term
          })
        } else {
          this.$emit('search', term)
        }
      } catch (err) {
        this.$swal({ position: 'top', type: 'error', text: err.message })
      }
      this.loading = false
      this.focus()
    }
  }
}
</script>
